import { Skeleton } from "@/components/ui/skeleton";

/**
 * Suspense fallback for lazily-loaded top-level pages. Page code is code-split
 * per route (see `lib/routes.tsx`), so there's a brief gap on first navigation
 * to a page while its chunk downloads. This renders a neutral page skeleton
 * during that gap — matching the app's "skeletons, never spinners" loading
 * convention.
 *
 * Deliberately generic (a heading line + a body block) rather than mimicking
 * any one page's layout: it stands in for every route, including chromeless
 * and public ones, so a page-specific shape would read wrong everywhere else.
 */
export function RouteFallback() {
  return (
    <div className="space-y-4" aria-busy="true">
      <Skeleton className="h-7 w-48" />
      <Skeleton className="h-4 w-72" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
